module.exports = __webpack_public_path__ + "static/media/icon-new-caret-down.ad1eac89.svg";